import {defaultTo, flow, get, stubArray} from '@logistics-frontend/utils'

import type {DestinationPoint, Product} from 'src/shared/types'

export const getProducts: (destination: DestinationPoint) => Product[] = flow(
  get('parcels[0].products'),
  defaultTo(stubArray()),
)
